import {authHeader} from './auth-header';

export const userService = {
    getUser,
    login,
    logout,
    getUserDevices,
    getUserClusters,
    getUserCluster,
    getUserClusterDevices,
    /*register,
    getAll,
    getById,
    update,
    delete: _delete*/
};

const config = {apiUrl: 'https://hive-backend.com/api/v1/user/'}
const user_key = 'abdcd';

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`${config.apiUrl}login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.userId) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem(user_key, JSON.stringify(user));
            }

            return user;
        });
}

function logout() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    
    // remove user from local storage to log user out
    localStorage.removeItem(user_key);
    
    return fetch(`${config.apiUrl}logout`, requestOptions);
}

function getUser(){
    return JSON.parse(localStorage.getItem(user_key));
}

function getUserDevices() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}devices?class=13`, requestOptions)
    .then(response => {
        if (!response.ok){
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                userService.logout();
            }
    
            return response.text()
                .then(data => {
                    if (data === '')
                        return Promise.reject({message: response.statusText});
                    else    
                        return Promise.reject({message: data});
                });
        }

        return response.json();
    })
    .catch(err => {
        return Promise.reject(err.message);
    });
}

function getUserClusters() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}clusters?class=13`, requestOptions)
    .then(response => {
        if (!response.ok){
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                userService.logout();
            }
    
            return response.text()
                .then(data => {
                    if (data === '')
                        return Promise.reject({message: response.statusText});
                    else    
                        return Promise.reject({message: data});
                });
        }

        return response.json();
    })
    .catch(err => {
        return Promise.reject(err.message);
    });
}

function getUserCluster(cluster) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}cluster/${cluster}`, requestOptions)
    //return fetch(`${config.apiUrl}cluster/${cluster}/info`, requestOptions)
    .then(response => {
        if (!response.ok){
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                userService.logout();
            }
    
            return response.text()
                .then(data => {
                    if (data === '')
                        return Promise.reject({message: response.statusText});
                    else    
                        return Promise.reject({message: data});
                });
        }

        return response.json();
    })
    .catch(err => {
        return Promise.reject(err.message);
    });
}

function getUserClusterDevices(cluster) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}cluster/${cluster}/devices`, requestOptions)
    //return fetch(`${config.apiUrl}cluster/${cluster}`, requestOptions)
    .then(response => {
        if (!response.ok){
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                userService.logout();
            }
    
            return response.text()
                .then(data => {
                    if (data === '')
                        return Promise.reject({message: response.statusText});
                    else    
                        return Promise.reject({message: data});
                });
        }

        return response.json();
    })
    .catch(err => {
        return Promise.reject(err.message);
    });
}
/*
function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse);
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}

function register(user) {
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${config.apiUrl}/users/register`, requestOptions).then(handleResponse);
}

function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${config.apiUrl}/users/${user.id}`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}*/

function handleResponse(response) {
    
    if (!response.ok){
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            logout();
            window.location.reload(true);
        }
        else if (response.status === 403){
            return Promise.reject("The password and/or username was incorrect")
        }

        return response.statusText
            .then(data => {
                if (data === '')
                        return Promise.reject(response.statusText);
                    else    
                        return Promise.reject(data);
            });
    }

    return response.json()
        .then(data => {
            return data;
        })
        .catch(err => {
            return Promise.reject(err.message);
        });
}